export default __webpack_public_path__ + "static/media/not-found.c6c9c3c2.png";